import { useState, useEffect } from 'react';
import { Box } from '@mui/material';
import { isEmpty } from '../../helpers';
import {
  StyledCharacterCount,
  StyledFieldLabel,
  StyledTextField,
} from './styled';

type PropsType = {
  disabled: boolean;
  value: string;
  onChange: (value: string) => void;
  onValidationChange: (isValid: boolean) => void;
};

const MAX_LENGTH = 250;

const AdditionalInfoField = ({
  disabled,
  value,
  onChange,
  onValidationChange,
}: PropsType) => {
  const [error, setError] = useState<Error | null>(null);

  const validateAdditionalInfo = (info: string) => {
    if (info.length > MAX_LENGTH) {
      setError(Error(`Cannot exceed ${MAX_LENGTH} characters`));
    } else {
      setError(null);
    }
  };

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = event.target.value;
    onChange(newValue);
    validateAdditionalInfo(newValue);
  };

  useEffect(() => {
    onValidationChange(!error && !isEmpty(value));
  }, [error, value, onValidationChange]);

  return (
    <Box>
      <StyledFieldLabel>Additional information</StyledFieldLabel>
      <StyledTextField
        placeholder="Company info/How you plan to use the Loudly API etc..."
        value={value}
        variant="outlined"
        multiline
        disabled={disabled}
        rows={4}
        error={!!error}
        helperText={error && error.message}
        onChange={handleChange}
      />
      <StyledCharacterCount>
        {value.length}/{MAX_LENGTH}
      </StyledCharacterCount>
    </Box>
  );
};

export default AdditionalInfoField;
